import { render, staticRenderFns } from "./casesDetail.vue?vue&type=template&id=0502fbb7&scoped=true"
import script from "./casesDetail.vue?vue&type=script&lang=js"
export * from "./casesDetail.vue?vue&type=script&lang=js"
import style0 from "./casesDetail.vue?vue&type=style&index=0&id=0502fbb7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_5qbk3fxidqh42wxgbx7uqb2gxe/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0502fbb7",
  null
  
)

export default component.exports